import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Divider, Link, TextField, Box } from '@material-ui/core';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import gradients from 'utils/gradients';
import { useMutation } from '@apollo/react-hooks';
import { loader } from 'graphql.macro';
import { useHistory } from 'react-router';
import Base from './Base';
import ButtonWithCircularProgress from 'components/ButtonWithCircularProgress';

const SignupMutation = loader('graphql/mutations/Signup.graphql');

const useStyles = makeStyles(theme => ({
    icon: {
        backgroundImage: gradients.indigo,
        color: theme.palette.white,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        position: 'absolute',
        top: -32,
        left: theme.spacing(3),
        height: 64,
        width: 64,
        fontSize: 32
    },
    loginForm: {
        marginTop: theme.spacing(3)
    },
    divider: {
        margin: theme.spacing(2, 0)
    },
    fields: {
        margin: theme.spacing(-1),
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            flexGrow: 1,
            margin: theme.spacing(1)
        }
    },
    links: {
        maxWidth: '100%',
        display: 'flex',
        '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%'
        }
    }
}));

const Login = () => {
    const classes = useStyles();
    const history = useHistory();
    const [submit, setSubmit] = useState(false);
    const [licence, setLicence] = useState("");
    const [email, setEmail] = useState("");
    const [signup, { loading, error }] = useMutation(SignupMutation, {
        onCompleted: () => {
            history.push('/emailSent');
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmit(true);
        signup({ variables: { input: { email: email, licence: licence } } });
    };

    const hasErrorLicence = () => {
        return submit && error && (
            error.message.includes('licence not found') ||
            error.message.includes('already signed up')
        );
    };

    const getErrorLicence = () => {
        if (!submit) return null;
        if (error && error.message.includes('licence not found')) return 'Licence non autorisée.';
        if (error && error.message.includes('already signed up')) return 'Déjà inscrit, connectez-vous.';
        return null;
    };

    const hasErrorEmail = () => {
        return submit && error && error.message.includes('licence ok but invalid email');
    };

    const getErrorEmail = () => {
        if (!submit) return null;
        if (error && error.message.includes('licence ok but invalid email')) return 'Cette adresse mail ne correspond pas à celle utilisé lors de l\'adhésion.';
        return null;
    };

    return (
        <Base title="S'inscrire" subtitle="S'inscrire pour accéder aux ouvertures" icon={<AssignmentIndIcon className={classes.icon} />}>
            <form className={classes.loginForm} onSubmit={handleSubmit}>
                <div className={classes.fields}>
                    <TextField fullWidth label="Licence" name="licence" variant="outlined"
                        value={licence} onChange={e => { setSubmit(false); setLicence(e.target.value); }}
                        error={hasErrorLicence()} helperText={getErrorLicence()} />
                    <TextField fullWidth label="Adresse mail" name="email" variant="outlined"
                        value={email} onChange={e => { setSubmit(false); setEmail(e.target.value); }}
                        error={hasErrorEmail()} helperText={getErrorEmail()} />
                </div>
                <Box marginTop={2}>
                    <ButtonWithCircularProgress size="large" type="submit" loading={loading} disabled={licence === "" || email === "" || loading}
                        label="S'inscrire" fullWidth />
                </Box>
            </form>
            <Divider className={classes.divider} />
            <div className={classes.links}>
                <Link align="left" color="secondary" component={RouterLink} to="/" underline="always" variant="subtitle2">
                    {'Déjà un compte?'}
                </Link>
            </div>
        </Base>
    );
};

export default Login;